import React, { useState } from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const TURKEY_GEO_URL = "https://raw.githubusercontent.com/alpers/Turkey-Maps-GeoJSON/master/tr-cities.json";

// Component artık 'veritabaniIlleri' prop'una ihtiyaç duymuyor.
const TurkiyeHaritasi = ({ tarihAraligi }) => {
    const [tooltipContent, setTooltipContent] = useState("");
    const [tooltipId] = useState(() => `turkey-map-tooltip-${Math.random().toString(36).substr(2, 9)}`);

    const formatCurrency = (value) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value || 0);

    const handleMouseEnter = (geo) => {
        const haritaIlAdi = geo.properties.name;
        
        // Debug için İzmir'i logla
        if (haritaIlAdi.toLowerCase().includes('izmir') || haritaIlAdi.toLowerCase().includes('İzmir')) {
            console.log('İzmir bulundu! Harita ismi:', haritaIlAdi, 'Karakter kodları:', 
                Array.from(haritaIlAdi).map(c => `${c}:${c.charCodeAt(0)}`).join(', '));
        }
        
        setTooltipContent(`<strong>${haritaIlAdi}</strong><br/>Veriler yükleniyor...`);

        if (!tarihAraligi || !tarihAraligi.baslangic || !tarihAraligi.bitis) {
            setTooltipContent(`<strong>${haritaIlAdi}</strong><br/>Lütfen bir tarih aralığı seçin.`);
            return;
        }
        
        // İl adını Türkçe karakterli formata çeviriyoruz
        const ilMap = {
            "Adana": "ADANA",
            "Adiyaman": "ADIYAMAN",
            "Afyon": "AFYONKARAHİSAR",
            "Afyonkarahisar": "AFYONKARAHİSAR",
            "Agri": "AĞRI",
            "Aksaray": "AKSARAY",
            "Amasya": "AMASYA",
            "Ankara": "ANKARA",
            "Antalya": "ANTALYA",
            "Ardahan": "ARDAHAN",
            "Artvin": "ARTVİN",
            "Aydin": "AYDIN",
            "Balikesir": "BALIKESİR",
            "Balıkesir": "BALIKESİR",
            "Bartin": "BARTIN",
            "Batman": "BATMAN",
            "Bayburt": "BAYBURT",
            "Bilecik": "BİLECİK",
            "Bingol": "BİNGÖL",
            "Bingöl": "BİNGÖL",
            "Bitlis": "BİTLİS",
            "Bolu": "BOLU",
            "Burdur": "BURDUR",
            "Bursa": "BURSA",
            "Canakkale": "ÇANAKKALE",
            "Cankiri": "ÇANKIRI",
            "Corum": "ÇORUM",
            "Denizli": "DENİZLİ",
            "Diyarbakir": "DİYARBAKIR",
            "Diyarbakır": "DİYARBAKIR",
            "Duzce": "DÜZCE",
            "Edirne": "EDİRNE",
            "Elazig": "ELAZIĞ",
            "Erzincan": "ERZİNCAN",
            "Erzurum": "ERZURUM",
            "Eskisehir": "ESKİŞEHİR",
            "Eskişehir": "ESKİŞEHİR",
            "Gaziantep": "GAZİANTEP",
            "Giresun": "GİRESUN",
            "Gumushane": "GÜMÜŞHANE",
            "Hakkari": "HAKKARİ",
            "Hatay": "HATAY",
            "Igdir": "IĞDIR",
            "Isparta": "ISPARTA",
            "Istanbul": "İSTANBUL",
            "Izmir": "İZMİR",
            "İzmir": "İZMİR",  // Türkçe karakterli alternatif
            "Kahramanmaras": "KAHRAMANMARAŞ",
            "Karabuk": "KARABÜK",
            "Karaman": "KARAMAN",
            "Kars": "KARS",
            "Kastamonu": "KASTAMONU",
            "Kayseri": "KAYSERİ",
            "Kilis": "KİLİS",
            "Kirikkale": "KIRIKKALE",
            "Kirklareli": "KIRKLARELİ",
            "Kırklareli": "KIRKLARELİ",
            "Kirsehir": "KIRŞEHİR",
            "Kırşehir": "KIRŞEHİR",
            "Kocaeli": "KOCAELİ",
            "Konya": "KONYA",
            "Kutahya": "KÜTAHYA",
            "Malatya": "MALATYA",
            "Manisa": "MANİSA",
            "Mardin": "MARDİN",
            "Mersin": "MERSİN",
            "Mugla": "MUĞLA",
            "Mus": "MUŞ",
            "Nevsehir": "NEVŞEHİR",
            "Nevşehir": "NEVŞEHİR",
            "Nigde": "NİĞDE",
            "Niğde": "NİĞDE",
            "Ordu": "ORDU",
            "Osmaniye": "OSMANİYE",
            "Rize": "RİZE",
            "Sakarya": "SAKARYA",
            "Samsun": "SAMSUN",
            "Sanliurfa": "ŞANLIURFA",
            "Siirt": "SİİRT",
            "Sinop": "SİNOP",
            "Sirnak": "ŞIRNAK",
            "Sivas": "SİVAS",
            "Tekirdag": "TEKİRDAĞ",
            "Tekirdağ": "TEKİRDAĞ",
            "Tokat": "TOKAT",
            "Trabzon": "TRABZON",
            "Tunceli": "TUNCELİ",
            "Usak": "UŞAK",
            "Van": "VAN",
            "Yalova": "YALOVA",
            "Yozgat": "YOZGAT",
            "Zonguldak": "ZONGULDAK"
        };
        
        // Haritadan gelen il adını doğru formata çevirip backend'e gönderiyoruz
        let normalizedIl = ilMap[haritaIlAdi];

        // Bulunamadıysa orijinal adı büyük harfe çevir
        if (!normalizedIl) {
            normalizedIl = haritaIlAdi.toUpperCase();
        }

        const url = `/api/reports/city-summary?start_date=${tarihAraligi.baslangic}&end_date=${tarihAraligi.bitis}&il=${normalizedIl}`;
        
        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (data.hata || data.toplam_adet === undefined) {
                    setTooltipContent(`<strong>${haritaIlAdi}</strong><br/>Veri bulunamadı.`);
                    return;
                }
                
                const icerik = `
                    <strong>${haritaIlAdi}</strong><hr style="margin: 2px 0;"/>
                    Toplam Adet: <strong>${data.toplam_adet}</strong><br/>
                    Toplam Ciro: <strong>${formatCurrency(data.toplam_ciro)}</strong><br/><br/>
                    <u>Kaynaklar (Adet/Ciro):</u><br/>
                    Whatsapp: ${data.kaynak_dokumu?.W?.adet || 0} / ${formatCurrency(data.kaynak_dokumu?.W?.ciro)}<br/>
                    Site: ${data.kaynak_dokumu?.S?.adet || 0} / ${formatCurrency(data.kaynak_dokumu?.S?.ciro)}<br/>
                    Resmi Evrak: ${data.kaynak_dokumu?.R?.adet || 0} / ${formatCurrency(data.kaynak_dokumu?.R?.ciro)}<br/><br/>
                    <u>Ödeme Türleri (Adet/Ciro):</u><br/>
                    Kapıda Ödeme: ${data.odeme_dokumu?.K?.adet || 0} / ${formatCurrency(data.odeme_dokumu?.K?.ciro)}<br/>
                    EFT/Havale: ${data.odeme_dokumu?.E?.adet || 0} / ${formatCurrency(data.odeme_dokumu?.E?.ciro)}<br/>
                    Online Ödeme: ${data.odeme_dokumu?.O?.adet || 0} / ${formatCurrency(data.odeme_dokumu?.O?.ciro)}
                `;
                setTooltipContent(icerik);
            })
            .catch(() => {
                setTooltipContent(`<strong>${haritaIlAdi}</strong><br/>Veri alınırken bir ağ hatası oluştu.`);
            });
    };

    return (
        <>
            <ComposableMap
                projection="geoMercator"
                // --- DEĞİŞİKLİKLER BURADA ---
                width={800}    // Haritanın içsel genişliğini belirliyoruz
                height={400}   // Haritanın içsel yüksekliğini daha az yapıyoruz
                projectionConfig={{
                    scale: 2200,   // Yeni en-boy oranına göre ölçeği güncelledik
                    center: [35.5, 39] // Merkezi biraz ayarladık
                }}
                // -------------------------
                data-tooltip-id={tooltipId}
                data-tooltip-html={tooltipContent}
                style={{ width: "100%", height: "auto" }} // Bu satır haritanın responsive olmasını sağlar
            >
                <Geographies geography={TURKEY_GEO_URL}>
                    {({ geographies }) =>
                        geographies.map(geo => (
                            <Geography
                                key={geo.rsmKey}
                                geography={geo}
                                onMouseEnter={() => handleMouseEnter(geo)}
                                onMouseLeave={() => setTooltipContent("")}
                                style={{
                                    default: {
                                        fill: "#D6D6DA",
                                        stroke: "#606060", // Çizgi rengi (gri)
                                        strokeWidth: 0.5,  // Çizgi kalınlığı
                                        outline: "none"
                                    },
                                    hover: {
                                        fill: "#3783c2",
                                        stroke: "#606060",
                                        strokeWidth: 0.5,
                                        outline: "none"
                                    },
                                    pressed: {
                                        fill: "#3783c2",
                                        stroke: "#606060",
                                        strokeWidth: 0.5,
                                        outline: "none"
                                    },
                                }}
                            />
                        ))
                    }
                </Geographies>
            </ComposableMap>
            <Tooltip 
                id={tooltipId}
                float 
                style={{
                    backgroundColor: '#272935', // Koyu arkaplan
                    color: '#ffffff',           // Beyaz yazı
                    borderRadius: '8px',        // Köşeleri yuvarlak
                    padding: '10px 15px',       // İç boşluk
                    fontSize: '12px',           // Font boyutu
                    lineHeight: '1.6'           // Satır yüksekliği
                }}
            />
        </>
    );
};

export default TurkiyeHaritasi;